"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Token = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
const component_styles_1 = require("@/components/domains/component/component.styles");
const token_utils_1 = require("@/components/domains/component/token.utils");
/**
 * 개별 CSS 커스텀 프로퍼티(토큰) 행.
 * mm-component-tokens 안에서만 사용합니다.
 * 앞선 행과 카테고리가 같으면 mm-component-tokens가 showCategory=false를 넘겨 태그 반복을 생략한다.
 */
let Token = class Token extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.showCategory = true;
    }
    render() {
        return (0, lit_1.html) `
      <div class="token-row">
        <div class="token-category">${this.renderCategoryTag()}</div>
        <mm-meta-item layout="stacked" label=${this.formatName()}></mm-meta-item>
      </div>
    `;
    }
    renderCategoryTag() {
        const label = (0, token_utils_1.tokenCategoryLabel)(this.name);
        if (!label || !this.showCategory)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-keyword-tag>${label}</mm-keyword-tag>
    `;
    }
    // state/surface/dimension 그룹이 바뀌는 경계에서만 '-'를 '.'으로 바꿔, 같은 그룹의 합성어(border-radius 등)는
    // 계속 '-'로 붙어 보이게 하면서 그룹 전환은 시각적으로 구분되게 한다.
    formatName() {
        const parts = this.name.split('-');
        const categories = parts.map((_, index) => (0, token_utils_1.categoryNameAt)(index, parts));
        return parts.reduce((result, word, index) => {
            if (index === 0)
                return word;
            const sameCategory = categories[index] === categories[index - 1];
            return `${result}${sameCategory ? '-' : '.'}${word}`;
        }, '');
    }
};
Token.styles = [component_styles_1.tokenStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Token.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], Token.prototype, "showCategory", void 0);
Token = __decorate([
    (0, decorators_js_1.customElement)('mm-token')
], Token);
exports.Token = Token;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9rZW4uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0b2tlbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBK0M7QUFDL0MscURBQTJEO0FBRTNELCtCQUE0QjtBQUM1QixzRkFBNkU7QUFDN0UsNEVBQStGO0FBRS9GOzs7O0dBSUc7QUFFSSxJQUFNLEtBQUssR0FBWCxNQUFNLEtBQU0sU0FBUSxnQkFBVTtJQUE5Qjs7UUFFdUIsU0FBSSxHQUFHLEVBQUUsQ0FBQTtRQUNSLGlCQUFZLEdBQUcsSUFBSSxDQUFBO0lBaUNsRCxDQUFDO0lBL0JDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOztzQ0FFdUIsSUFBSSxDQUFDLGlCQUFpQixFQUFFOytDQUNmLElBQUksQ0FBQyxVQUFVLEVBQUU7O0tBRTNELENBQUE7SUFDSCxDQUFDO0lBRU8saUJBQWlCO1FBQ3ZCLE1BQU0sS0FBSyxHQUFHLElBQUEsZ0NBQWtCLEVBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFBO1FBQzNDLElBQUksQ0FBQyxLQUFLLElBQUksQ0FBQyxJQUFJLENBQUMsWUFBWTtZQUFFLE9BQU8sYUFBTyxDQUFBO1FBRWhELE9BQU8sSUFBQSxVQUFJLEVBQUE7d0JBQ1MsS0FBSztLQUN4QixDQUFBO0lBQ0gsQ0FBQztJQUVELG9GQUFvRjtJQUNwRiwyQ0FBMkM7SUFDbkMsVUFBVTtRQUNoQixNQUFNLEtBQUssR0FBRyxJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQTtRQUNsQyxNQUFNLFVBQVUsR0FBRyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLENBQUMsSUFBQSw0QkFBYyxFQUFDLEtBQUssRUFBRSxLQUFLLENBQUMsQ0FBQyxDQUFBO1FBRXhFLE9BQU8sS0FBSyxDQUFDLE1BQU0sQ0FBQyxDQUFDLE1BQU0sRUFBRSxJQUFJLEVBQUUsS0FBSyxFQUFFLEVBQUU7WUFDMUMsSUFBSSxLQUFLLEtBQUssQ0FBQztnQkFBRSxPQUFPLElBQUksQ0FBQTtZQUU1QixNQUFNLFlBQVksR0FBRyxVQUFVLENBQUMsS0FBSyxDQUFDLEtBQUssVUFBVSxDQUFDLEtBQUssR0FBRyxDQUFDLENBQUMsQ0FBQTtZQUNoRSxPQUFPLEdBQUcsTUFBTSxHQUFHLFlBQVksQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxHQUFHLEdBQUcsSUFBSSxFQUFFLENBQUE7UUFDdEQsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFBO0lBQ1IsQ0FBQzs7QUFsQ00sWUFBTSxHQUFHLENBQUMsOEJBQVcsQ0FBQyxDQUFBO0FBQ0Q7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO21DQUFVO0FBQ1I7SUFBNUIsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxDQUFDOzJDQUFvQjtBQUhyQyxLQUFLO0lBRGpCLElBQUEsNkJBQWEsRUFBQyxVQUFVLENBQUM7R0FDYixLQUFLLENBb0NqQjtBQXBDWSxzQkFBSyJ9